import React, { useEffect, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dispatcher } from '../../helpers/projectHelper';
import { calculateSafeFrameSize } from '../../helpers/unityHelper';
import {
  cameraSettingsSelector,
  selectSafeFrameSize,
  setGlobalHeight,
  setGlobalSafeCameraFlag,
  setGlobalWidth,
  setSafeFrameSize,
} from '../../redux/slicers/camera/cameraSettings';

export const SafeCameraFrame = memo((props) => {
  const dispatch = useDispatch();
  const { globalWidth, globalHeight, canvasFrameWidth, canvasFrameHeight, globalSafeCameraFlag } =
    useSelector(cameraSettingsSelector);
  const { width, height } = useSelector(selectSafeFrameSize);

  const container = {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    padding: '2px',
    pointerEvents: 'none',
    // backgroundColor: "rgba(0,0,0,0.5)"
  };

  const innerContainer = {
    position: 'absolute',
    display: 'block',
    // width: `${width}px`,
    // height: `${height}px`,
    width: `${canvasFrameWidth}px`,
    height: `${canvasFrameHeight}px`,
    backgroundColor: 'transparent',
    borderTop: `${(canvasFrameHeight - height) / 2}px solid rgba(0,0,0,0.5)`,
    borderLeft: `${(canvasFrameWidth - width) / 2}px solid rgba(0,0,0,0.5)`,
    borderBottom: `${(canvasFrameHeight - height) / 2}px solid rgba(0,0,0,0.5)`,
    borderRight: `${(canvasFrameWidth - width) / 2}px solid rgba(0,0,0,0.5)`,
    transition: 'all 150ms linear'
    // backgroundColor: "#ffff00",
    // border: "2px solid #ff0000"
  };

  // const canvasRatio = canvasFrameWidth === 0 || canvasFrameHeight === 0 ? 1 : Number.parseFloat((canvasFrameWidth/canvasFrameHeight).toFixed(2));
  // const previewRatio = globalWidth === 0 || globalHeight === 0 ? 1 : Number.parseFloat((globalWidth/globalHeight).toFixed(2));

  useEffect(() => {
    // we need to have this canvasFrameWidth, canvasFrameHeight in case of resizing
    const result = calculateSafeFrameSize({ 
        cameraHeight: globalHeight,
        cameraWidth: globalWidth
    })

    if (!result) return;

    const { width, height } = result
    dispatch(setSafeFrameSize({ width, height }));

  }, [globalWidth, globalHeight, canvasFrameWidth, canvasFrameHeight]);

  if (!globalSafeCameraFlag) return null;

  return (
    <div style={container}>
      <div style={innerContainer}></div>
    </div>
  );
});


export const updateCameraFrameWhileTakingScreenshot = ({ width, height }) => {

  if(!width && !height) return;

  dispatcher(setGlobalWidth(width));
  dispatcher(setGlobalHeight(height));
  dispatcher(setGlobalSafeCameraFlag(true));

  return;
}